import { useTranslation } from "react-i18next"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import toastr from "toastr"

interface UseApplyDiscountMutationParams {
  orderUuid: string
  deviceId: string
}

export const useApplyDiscountMutation = ({
  orderUuid,
  deviceId
}: UseApplyDiscountMutationParams) => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (discountCode: string) => {
      if (!discountCode.trim()) {
        throw new Error("Discount code cannot be empty")
      }
      
      return axios.patch(`/api/registration/order/${orderUuid}/?device_id=${deviceId}`, {
        discount_code: discountCode.trim(),
      })
    },
    onSuccess: () => {
      // Invalidate and refetch order data
      queryClient.invalidateQueries({ queryKey: ["order", orderUuid] })
      toastr.success(t("discount.applied_successfully"))
    },
    onError: (error: any) => {
      const message = String(
        error.response?.data?.[0] || "Failed to apply discount"
      )
      toastr.error(message)
    },
  })
}